import { Helmet } from "react-helmet"
import { useTranslation } from "react-i18next"
import Breadcrumb from "src/components/layouts/Common/Breadcrumb"
import Sidebar from "src/components/layouts/sidebar/Sidebar"
import FinanceList from "src/components/panel/finance/FinanceList"

const FinanceListView=()=>{
    const {t}=useTranslation()
    return<>
    <Helmet>
        <title>{t('finance_list_tab')}</title>
    </Helmet>
    <Sidebar>
        <Breadcrumb title={t("finance_list_title")} subtitle={t('finance_list_subtitle')}/>
        <FinanceList/>
    </Sidebar>
    
    
    
    </>
}
export default FinanceListView